module.exports = __webpack_public_path__ + "static/media/avax.f02892d4.png";